class AnnouncementTicker extends HTMLElement {
  constructor() {
    super();
    this.track = null;
    this.speed = 50;
    this.animationId = null;
    this.isPaused = false;
    this.position = 0;
    this.trackWidth = 0;
    this.singleSetWidth = 0;
  }

  connectedCallback() {
    this.track = this.querySelector('[data-ticker-track]');
    if (!this.track) return;

    this.speed = parseInt(this.getAttribute('data-speed')) || 50;
    this.isPaused = false;

    this.init();

    this.addEventListener('mouseenter', () => this.pause());
    this.addEventListener('mouseleave', () => this.resume());
    document.addEventListener('visibilitychange', () => {
      document.hidden ? this.pause() : this.resume();
    });

    if (window.ResizeObserver) {
      new ResizeObserver(() => this.init()).observe(this);
    }
  }

  init() {
    // Remove previously cloned sets
    this.track.querySelectorAll('[data-clone]').forEach(el => el.remove());

    const original = this.track.querySelector('[data-ticker-set]');
    if (!original) return;

    this.singleSetWidth = original.offsetWidth;
    const containerWidth = this.offsetWidth;

    // Clone enough sets to fill at least 2x the container
    const clonesNeeded = Math.ceil((containerWidth * 2) / this.singleSetWidth) + 1;
    for (let i = 0; i < clonesNeeded; i++) {
      const clone = original.cloneNode(true);
      clone.setAttribute('data-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);
    }

    this.position = 0;
    this.track.style.transform = `translate3d(0, 0, 0)`;
    this.startAnimation();
  }

  startAnimation() {
    if (this.animationId) cancelAnimationFrame(this.animationId);

    let lastTime = null;
    const animate = (timestamp) => {
      if (!lastTime) lastTime = timestamp;
      const delta = timestamp - lastTime;
      lastTime = timestamp;

      if (!this.isPaused) {
        this.position -= (this.speed * delta) / 1000;

        // Reset position when one full set has scrolled past
        if (Math.abs(this.position) >= this.singleSetWidth) {
          this.position += this.singleSetWidth;
        }

        this.track.style.transform = `translate3d(${this.position}px, 0, 0)`;
      }

      this.animationId = requestAnimationFrame(animate);
    };

    this.animationId = requestAnimationFrame(animate);
  }

  pause() {
    this.isPaused = true;
  }

  resume() {
    this.isPaused = false;
  }

  disconnectedCallback() {
    if (this.animationId) cancelAnimationFrame(this.animationId);
  }
}

if (!customElements.get('announcement-ticker')) {
  customElements.define('announcement-ticker', AnnouncementTicker);
}
